import { render, staticRenderFns } from "./SelectArticle.vue?vue&type=template&id=155f18f8&scoped=true"
import script from "./SelectArticle.vue?vue&type=script&lang=js"
export * from "./SelectArticle.vue?vue&type=script&lang=js"
import style0 from "./SelectArticle.vue?vue&type=style&index=0&id=155f18f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155f18f8",
  null
  
)

export default component.exports